import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

type SideNavContextValue = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  toggle: () => void;
};

const SideNavContext = createContext<SideNavContextValue | null>(null);

export function SideNavProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const value = useMemo(
    () => ({ isOpen, setIsOpen, toggle: () => setIsOpen((s) => !s) }),
    [isOpen],
  );
  return (
    <SideNavContext.Provider value={value}>{children}</SideNavContext.Provider>
  );
}

export function useSideNav() {
  const ctx = useContext(SideNavContext);
  if (!ctx) throw new Error("useSideNav must be used within SideNavProvider");
  return ctx;
}
